// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3gjR5","title":"Info_title__1CpMs","links":"Info_links__1QgFt","link":"Info_link__BIwIH","logo":"Info_logo__o6xUy"};